
<div class="container">
  <form #dartForm="ngForm" (ngSubmit)="send()">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <h4>Message to Transition Lead(s)</h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-8 card-block">
        <error [error]="error"></error>
        <div class="alert alert-success" [hidden]="!sent">
          <button class="close" type="button" (click)="sent = false"><span aria-hidden="true">&times;</span></button>Your message has been successfully sent to the Transition Leads.
        </div>
        <div class="form-group">
          <label class="required" for="message"></label> Please provide a reason for rejecting the COA document.
          <textarea class="form-control" id="message" [(ngModel)]="message" name="message" rows="5" required></textarea>
        </div>
        <div class="float-right">
          <div class="btn-group">
            <button class="btn btn-outline-secondary" type="button" (click)="cancel()"><span [hidden]="sent">Back</span><span [hidden]="!sent">Close</span></button>
          </div>
          <div class="btn-group">
            <button class="btn btn-primary" type="submit" [disabled]="loadScreen || sent"> <span [hidden]="loadScreen">Send</span><span [hidden]="!loadScreen">Sending...</span><i class="fa fa-spinner fa-spin ml-2" [hidden]="!loadScreen"></i></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>